import { Component, OnInit, Inject, ViewChild, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { HistoryService } from './history.service';
import { User } from '../users/user.model';
import { UserFieldComponent } from '../forms/user-field.component';
import { ErrorDialogComponent } from '../shared/error-dialog.component';
import { ConfirmDialogComponent } from '../shared/confirm-dialog.component';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-share-history',
  templateUrl: './share-history.component.html',
  styleUrls: ['./share-history.component.scss']
})
export class ShareHistoryComponent implements OnInit {

  @ViewChild("userField") userField: UserFieldComponent;
  currentUser = this.authService.currentUser;
  loading: boolean = true;
  user: User;
  users: User[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private dialog: MatDialog,
    private historyService: HistoryService,
    private ngZone: NgZone) { }

  ngOnInit() {
    this.historyService.shareUsers().subscribe(
      (users) => { 
        this.users = users.filter((u) => u.id !== this.currentUser.id);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    )
  }

  onValueChange(event) {
    switch(event.field) {
    case "user":
      this.user = event.value != null ? event.value.stored : null;
      break;
    }
  }

  onAdd(user) {
    if (user == null || user.id === this.currentUser.id) { return }
    this.userField.reset();
    this.addUser(user);
    this.historyService.addShareUser(user).subscribe(
      (success) => { },
      (error) => {
        this.removeUser(user);
        this.ngZone.run(() => {this.showErrorDialog("Failed to share history")});
      }
    )
  }

  addUser(user) {
    let existing = this.users.find((u) => u.id === user.id);
    if (existing == null) {
      this.users.unshift(user);
    }
  }

  confirmRemove(user) {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      height: '240px',
      width: '320px',
      data: {
        action: "Unshare",
        message: "Unshare history with",
        question: user.name
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null && result.confirm === true) {
        this.onRemove(user);
      }
    })
  }

  onRemove(user) {
    this.removeUser(user);
    this.historyService.removeShareUser(user).subscribe(
      (success) => { },
      (error) => {
        this.addUser(user);
        this.ngZone.run(() => {this.showErrorDialog("Failed to unshare history")});
      }
    )
  }

  removeUser(user) {
    let index = this.users.findIndex((u) => u.id === user.id)
    this.users.splice(index, 1);
  }

  showErrorDialog(message) {
    let dialogRef = this.dialog.open(ErrorDialogComponent, {
      height: '240px',
      width: '320px',
      data: {message: message}
    });
    setTimeout(() => dialogRef.close(), 6000);
  }
}


// WEBPACK FOOTER //
// ./src/app/history/share-history.component.ts